module.exports = __webpack_public_path__ + "img/OrdersTrackingInActive.6dd53870.svg";